import * as Yup from 'yup';

const validationSchema = Yup.string()
  .email()
  .required();
export default email => validationSchema.isValidSync(email);
